<h2 mat-dialog-title>Versiune Git</h2>
<mat-dialog-content>
  <p>Build Date: {{data.appVersion.date}}</p>
  <p>Branch: {{data.appVersion.branch}}</p>
  <p>App Version: {{data.appVersion.version}}</p>
  <p>Revision: {{data.appVersion.revision}}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Renunță</button>
</mat-dialog-actions>